export default class DtoUsage {
    constructor(obj) {
        this.idStation = obj.idStation
        this.startDate = obj.startDate
        this.endDate = obj.endDate
        this.usageCode = obj.usageCode
        this.descriptive = obj.descriptive
    }
}